import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonIndent} from 'mui-tiptap';

const StyledEditorMenuButtonIndent = styled(MenuButtonIndent)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonIndent.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonIndent;
